module.exports = __webpack_public_path__ + "img/card1_img_1.6bea25df.jpg";